"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Tag = {
  styles: function styles(theme) {
    return {
      root: {
        padding: [theme.spacing.base / 4, theme.spacing.base / 2],
        borderRadius: 4
      },
      icon: {
        paddingInlineStart: theme.spacing.base / 2,
        paddingInlineEnd: 0
      },
      close: {
        paddingInlineStart: 0,
        paddingInlineEnd: theme.spacing.base / 2
      },
      compactIcon: {
        paddingInlineEnd: 0
      },
      translucent: {
        backgroundColor: "".concat(theme.colors.themeBase, "4D") // 30% opacity
      }
    };
  }
};
var _default = exports.default = Tag;